import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import Cards from './Cards'
import Table from './Table'

import style from './style.sass'

@withBoundary
@withRouter
@inject('store') @observer
class Upgrade extends Component {
  state = {
    loading:false
  }
  componentDidMount() {
    this.props.store.permissions.hideModal()
    this.props.store.subscription.getPlans()
  }
  upgrade = async (value) => {
    const {subscription, user} = this.props.store
    this.setState({loading:true})
    if (!user.data.billing_plan.is_free_plan) {
      await subscription.getCards()
    }
    user.selectPlan(value)
    if (subscription.cards.data.length) {
      await user.changePlan(value)
      this.props.history.push('/manager')
    } else {
      this.props.history.push('/checkout')
    }
  }
  render() {
    const {data} = this.props.store.user
    const currentPlanID = data.billing_plan.id
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Upgrade Plan'/>
        <Cards currentPlanID={currentPlanID} upgrade={this.upgrade} loading={this.state.loading}/>
        <Table currentPlanID={currentPlanID} upgrade={this.upgrade} loading={this.state.loading}/>
      </div>
    )
  }
}

export default Upgrade
